import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { CustomerComponent } from "./customer.component";
import { CustomerService } from "./customer.service";
import { ListComponent } from "./list/list.component";
import { EditComponent } from "./edit/edit.component";

import { routing } from "./customer.routing";

import {
  FormsModule as AngularFormsModule,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { ChartsModule } from "ng2-charts";
import { ApiEvsService } from "app/common/services/ApiEvs.service";
import {
  ConfirmDialogModule,
  GrowlModule,
  TooltipModule
} from "primeng/primeng";
import { SelectModule } from "ng-select";
import { CardModule } from "../../../../layout/card";
import { ModalModule } from "ngx-bootstrap/modal";
import { ImageService } from "../../../imageService";
import { BsDatepickerModule } from 'ngx-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { InstallWarrantyInformationComponent } from './installWarrantyInformation/installWarrantyInformation.component';

@NgModule({
  imports: [
    CommonModule,
    routing,
    FormsModule,
    ReactiveFormsModule,
    AngularFormsModule,
    ChartsModule,
    ConfirmDialogModule,
    GrowlModule,
    TooltipModule,
    SelectModule,
    CardModule,
    ModalModule.forRoot(),
    BsDatepickerModule,
    TranslateModule.forChild(),
  ],
  declarations: [CustomerComponent, ListComponent, EditComponent, InstallWarrantyInformationComponent],
  providers: [CustomerService, ApiEvsService, ImageService]
})
export class CustomerModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/customer/customer.module.ts